<template>
    <b-select v-model="localValue" class="form-control">
        <option>Select</option>
    </b-select>
</template>

<script>

import debounce from 'lodash/debounce';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    props: ['value', 'parentId'],
    components: {},

    data() {
        return {
            localValue: null,
        }
    },
    computed: {
        ...mapState('icd', { icdLoading: 'isFindPending' }),
        ...mapGetters('icd', { findIcdInStore: 'find', getIcd: 'get' }),
        idc() {
            return this.findIcdInStore().data;
        },

        items() {

        }
    },
    watch: {
        value(newValue) {
            this.localValue = newValue;
        },
        localValue: debounce(function (newVal) {
            this.$emit('input', this.localValue);
        }, 10),
    },
    created() {
        this.localValue = this.value;
    },
    methods: {
        fetch() {
            if (this.parentId) {

            }
        }
    }

}
</script>
